// URL helpers — keep canonical post URL building in one place.

/**
 * Build the canonical URL path for a blog post.
 * Format: /<primary-category-slug>/<post-slug>
 * Falls back to /post/<slug> if the post has no category (defensive).
 */
export function postUrl(post) {
  if (!post || !post.slug) return "/";
  const cat = post.categories?.[0];
  return cat ? `/${cat}/${post.slug}` : `/post/${post.slug}`;
}
